import { render, staticRenderFns } from "./ModalKirimDus.vue?vue&type=template&id=0e3a618f&"
import script from "./ModalKirimDus.vue?vue&type=script&lang=js&"
export * from "./ModalKirimDus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports